import WPAPI from "wpapi";

export const wpLogin = (credentials) => {
  const { user, password } = credentials;

  const wp = new WPAPI({
    endpoint: "https://vinosdev.com/wp-json",
    // This assumes you are using basic auth, as described further below
    username: user,
    password: password,
  });
  
  return wp.users().me()

};
